import { render, staticRenderFns } from "./FJSPoster.vue?vue&type=template&id=510cc92a&scoped=true"
import script from "./FJSPoster.vue?vue&type=script&lang=js"
export * from "./FJSPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510cc92a",
  null
  
)

export default component.exports